module.exports = __webpack_public_path__ + "img/nihonolive.58919175.png";